import {
  AssociateCardSummary,
  ReportingTeamUser,
  TeamProfile,
} from '../../../../Types';

export interface SideMenuControllerProps {
  teamProfile: TeamProfile;
  hash: string;
  setHash: React.Dispatch<any>;
  openLinkHash: string | null;
  setOpenLinkHash: React.Dispatch<any>;
  expanded: boolean;
  setExpanded: React.Dispatch<any>;
  setFocusProfile: React.Dispatch<any>;
}

export interface RichCardProps {
  profile: ReportingTeamUser;
  associateCardSummary: AssociateCardSummary[];
  filter: string;
  sideMenuSource: SIDE_MENU_PATH;
  isBottomQuartile: boolean;
  BottomQuartileRoutingInfo: string;
  currentVertical: string;
  setHash: React.Dispatch<any>;
  setOpenLinkHash: React.Dispatch<any>;
  setExpanded: React.Dispatch<any>;
  setFocusProfile: React.Dispatch<any>;
}

export interface TeamProps {
  teamProfile: TeamProfile;
}

export interface AssociateCardProps {
  defaultVertical: string;
  teamProfile: TeamProfile;
  associateCardSummary: AssociateCardSummary[];
  summaryState: string;
  metricState: string;
  insightState: string;
  goalState: string;
  verticalOptions: string[];
  verticalValue: string;
  setVerticalValue: React.Dispatch<any>;
}

export enum RELATION_TO_USER {
  ALL_TMS = 'ALL_TM',
  ALL_ASSOCIATES = 'ALL_CSA',
  DIRECT_REPORT = 'DIRECT_REPORT',
  COACHEE = 'COACHEE',
}

export enum SIDE_MENU_PATH {
  ALL_TMS = '#all_tm',
  ALL_ASSOCIATES = '#all_csa',
  DIRECT_REPORT = '#direct',
  SHARED_PROFILE = '#shared',
}

export interface Contact {
  contact: string;
  contactStatus: string;
}

export interface Opportunity {
  category: string;
  contacts: Contact[];
}

export interface AssociateInsight {
  associateID: string;
  opportunities: Opportunity[];
}

export type AssociateGoals = {
  coachingIDs: string[];
  createdBy: string;
  description: string;
  justification: null;
  level: string;
  metric: string;
  outcome: string;
  periodType: string;
  periodValue: string;
  status: string;
  targetValue: string;
  userID: string;
  userName: string;
  goalID: string;
  endDate: string;
};

export enum ARCFilters {
  COACHINGS = 'coachings',
  PERFORMANCE = 'performance',
  OPPORTUNITIES = 'opportunities',
  KUDOS = 'kudos',
  GOALS = 'goals',
}

export const isValidARCFilter = (
  filter?: string | null
): filter is ARCFilters => {
  return (
    filter !== null && Object.values(ARCFilters).includes(filter as ARCFilters)
  );
};

export type BottomQuartileValue = {
  [key: string]: string;
};

export enum TrendIndicator {
  NEGATIVE = 'negative',
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
}
